import React from 'react';
import { Hero } from './components/Hero';
import { Testimonials } from './components/Testimonials';
import { PainSection } from './components/PainSection';
import { TomosSection } from './components/TomosSection';
import { BonosSection } from './components/BonosSection';
import { PricingSection } from './components/PricingSection';
import { ComparisonTable } from './components/ComparisonTable';
import { GuaranteeSection } from './components/GuaranteeSection';
import { FAQSection } from './components/FAQSection';
import { CostTable } from './components/CostTable';
import { FinalCTA } from './components/FinalCTA';
import { Footer } from './components/Footer';
import { MetaPixel } from './components/MetaPixel';
import { TopAnnouncementBar } from './components/TopAnnouncementBar';
import { TrustMarquee } from './components/TrustMarquee';
import { MoreTestimonials } from './components/MoreTestimonials';
import { PurchaseNotifications } from './components/PurchaseNotifications';
export function App() {
  return <div className="min-h-screen bg-graphite text-white font-body selection:bg-electric selection:text-white" data-id="element-0">
      <MetaPixel data-id="element-1" />
      <TopAnnouncementBar data-id="element-2" />
      <TrustMarquee data-id="element-3" />
      <Hero data-id="element-4" />
      <PainSection data-id="element-5" />
      <Testimonials data-id="element-6" />
      <TomosSection data-id="element-7" />
      <BonosSection data-id="element-8" />
      <PricingSection data-id="element-9" />
      <ComparisonTable data-id="element-10" />
      <MoreTestimonials data-id="element-11" />
      <GuaranteeSection data-id="element-12" />
      <FAQSection data-id="element-13" />
      <CostTable data-id="element-14" />
      <FinalCTA data-id="element-15" />
      <Footer data-id="element-16" />
      <PurchaseNotifications data-id="element-17" />
    </div>;
}